<style lang="less" scoped>
@import "./product-detail.less";

.price-tip {
  background: #e97987;
  color: #ffffff;
  max-width: 300px;
  padding: 5px 10px;
  margin-bottom: 30px;
}
</style>
<template>
  <div style="width:1100px;margin:0 auto;" :style="{ transition: 'all 0.3s', opacity: showPage ? 1 : 0 }">
    <div class="top">
      <div class="photo-album">
        <album :images="productSpec.photos"></album>
      </div>

      <div class="basic-info">
        <!--商品标签-->
        <ul class="tag">
          <li v-if="$enums.productMark.label(currentSpec.mark)" :class="currentSpec.mark">
            {{ $enums.productMark.label(currentSpec.mark) }}</li>
        </ul>
        <!--商品标签结束-->

        <!--商品名称-->
        <p class="product-name">{{ productSpec.specName }}</p>
        <!--商品名称结束-->

        <p class="shop-price-info basic-info-content">
          <span class="name">零售价：</span>
          <span class="price">{{ productSpec.price | price }}</span>
        </p>

        <p class="price-tip" v-if="currentSpec.discountPromotion && currentSpec.discountPromotion.title">
          {{ currentSpec.discountPromotion.title }}
        </p>

        <p class="sale-price-info basic-info-content">
          <span class="name">内购价：</span>
          <span class="price">
            <strong>{{ currentSpec.price | price }}</strong>
          </span>
        </p>

        <div class="product-specs basic-info-content">
          <span class="name">颜色：</span>
          <ul class="spec-list">
            <li v-for="specInfo in this.specData" :class="[(specId == specInfo.id) ? 'activity' : '']">
              <router-link :to="{ name: 'product-detail', params: { id: specInfo.id } }">
                <img :src="specInfo.productSpec.photos[0] | imgUrl" alt="">
                <i class='choose el-icon-check'></i>
              </router-link>
            </li>
          </ul>
        </div>

        <div class="basic-info-content">
          <span class="name">数量：</span>
          <el-input-number v-model="num" size="small" @change="handleChange" :min="1" label="描述文字"></el-input-number>
        </div>

        <el-button v-if="!specIsSellOut" class="add-cart" @click="addCart">
          <svg-icon class="add-cart-icon" icon-class="cart" />
          加入购物车
        </el-button>

        <el-button v-if="specIsSellOut" class="btn-sell-out" disabled>
          售馨
        </el-button>
      </div>
    </div>

    <div class="content-detail">

      <div class="left">
        <img v-for="qrcode in qrcodes" :src="qrcode" alt="">
      </div>

      <div class="right" v-html="product.description"></div>

    </div>

  </div>
</template>

<script>
import _ from 'lodash';
import { isSellOut } from "@/helpers";
import CartOperator from '@/mixins/CartOperator'
const sallOutImagePath = require('../../assets/watermark/sell-out.png');
export default {
  name: 'ProductDetail',
  mixins: [CartOperator],
  data() {
    return {
      num: 1,
      specId: this.$route.params.id,
      currentSpec: {},
      specData: [],
      specDetail: '',
      showPage: false
    };
  },
  methods: {
    handleChange(value) {
      // console.log(value);
    },
    //获取选中规格信息
    async getActivityProduct() {
      const id = this.specId;
      // TODO: 此处需优化document：withRels
      // const result = await this.$store.dispatch('activityProducts/document', { id, withRels : ['productSpec', 'product'] });
      const result = await this.$store.dispatch('activityProducts/document', id);
      let document = result.document;
      const photos = document.productSpec.photos
      document.productSpec.photos = photos.filter(photo => !photo.isDeleted)

      this.currentSpec = document;
      this.specId = this.currentSpec.id;
      this.getActivitySpecs(this.currentSpec.productId);
    },
    //获取选中活动所有规格信息
    async getActivitySpecs(productId) {
      const result = await this.$store.dispatch('activityProducts/collection', { query: { productId } });
      this.specData = result.collection;
    },
    addCart() {
      const product = { productInfo: this.currentSpec, num: this.num };
      const productName = this.currentSpec.product.productName;
      this.addToCart(product)
    }
  },
  async mounted() {
    await this.getActivityProduct();
    this.$nextTick(() => {
      this.showPage = true
    })
  },
  computed: {
    productSpec() {
      let productSpec = _.isEmpty(this.currentSpec) ? {} : this.currentSpec.productSpec;
      let productSpecPhotos = _.isEmpty(this.currentSpec) ? [] : this.currentSpec.productSpec.photos;
      productSpecPhotos.forEach((item) => {
        item.img = item.url;
        item.watermark = isSellOut(this.currentSpec);
        item.watermarkImage = isSellOut(this.currentSpec) ? sallOutImagePath : '';
      });
      return productSpec;
    },
    specIsSellOut() {
      let productSpec = _.isEmpty(this.currentSpec) ? {} : this.currentSpec.productSpec;
      return isSellOut(this.currentSpec);
    },
    product() {
      return _.isEmpty(this.currentSpec) ? {} : this.currentSpec.product;
    },
    qrcodes() {
      return this.$config.qrcodes
    },
  },
  watch: {
    '$route'(to, from) {
      this.specId = this.$route.params.id;
      this.getActivityProduct();
    }
  }
};
</script>
